import TransactionCreditRow from './TransactionCreditRow';

export default TransactionCreditRow;
